<div class="tabs-container">
    <ul class="tab">
        @if(showNav) {
        <button [disabled]="beforePage" class="change-page initial" (click)="scrollTo('left')"
            [class.disabled]="beforePage">
            <mat-icon svgIcon="Chevron Left"></mat-icon>
        </button>
        }
        <div class="container-tab" #tabContainer>
            @for(tab of tabs; track tab.title; let i = $index) {
            <button class="tab-button" (click)="selectTab(tab, i); scrollToTab(i)" [class.active]="tab.active"
                [class.disabled]="tab?.disabled" [disabled]="tab?.disabled">
                <li class="title-tab" [ngClass]="{ 'contain-hover-icon': tab?.alert?.iconHover }" [ngStyle]="styleTab">
                    @if(tab.icon){
                        <icon-induxtry [icon]="{icon: tab.icon, width: 24, height: 24}"></icon-induxtry>
                    }
                    <span>{{ tab.title }}</span>
                    @if(tab?.alert?.isIcon && tab?.alert?.active && tab?.alert?.icon !== 'loading'){
                    <mat-icon class="tab-icon-not-hover" [svgIcon]="tab?.alert?.icon" [matTooltip]="tab?.alert?.tooltip"
                        [matTooltipPosition]="tab?.alert?.position || 'below'"
                        matTooltipClass="induxtry-tooltip"></mat-icon>
                    }
                    @if(tab?.alert?.isIcon && tab?.alert?.active && tab?.alert?.icon !== 'loading'){
                    <mat-icon class="tab-icon-hover" [svgIcon]="tab?.alert?.iconHover"
                        [matTooltip]="tab?.alert?.tooltip" [matTooltipPosition]="tab?.alert?.position || 'below'"
                        matTooltipClass="induxtry-tooltip"></mat-icon>
                    }
                    @if(tab?.alert?.isIcon && tab?.alert?.active && tab?.alert?.icon === 'loading'){
                    <div class="loading-status" [svgIcon]="tab?.alert?.icon" [matTooltip]="tab?.alert?.tooltip"
                        [matTooltipPosition]="tab?.alert?.position || 'below'" matTooltipClass="induxtry-tooltip">
                        <loading [size]="'20px'" class="load-size" [showOldLoading]="true"></loading>
                    </div>
                    }
                    @if(!tab?.alert?.isIcon && tab?.alert?.text){
                    <div class="total">
                        <span class="sub-text" style="font-size: 12px;">
                            {{ tab?.alert?.text }}
                        </span>
                    </div>
                    }
                </li>

            </button>
            }
        </div>
        <button *ngIf="showNav" [disabled]="afterPage" class="change-page end" (click)="scrollTo('right')"
            [class.disabled]="afterPage">
            <mat-icon svgIcon="Chevron Right"></mat-icon>
        </button>

        @if(totalDiv) {
        <div class="total-div">
            <span>{{totalDiv}}</span>
        </div>
        }

    </ul>

    <div class="divider-tab"></div>

    <div class="content-tab" [ngClass]="{ 'disable-background': disableBackground }"
        [ngStyle]="{'width': width, 'height': height }">
        <ng-content></ng-content>
    </div>
</div>